<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text">
        {{ $t("soil-use-and-risks") }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            
            <tbody>
              <tr>
                <td>{{ $t("building-ground-assumption") }}</td>
                <td>{{ plotItem.GRN_SOI }}</td>
              </tr>
              <tr>
                <td><b>{{ $t("use-of-geothermal-probes") }}</b></td>
                <td><b>{{ plotItem.GRN_TRM }}</b></td>
              </tr>
              <tr>
                <td><b>{{ $t("use-of-groundwater") }}</b></td>
                <td><b>{{ plotItem.GRN_GWU }}</b></td>
              </tr>
              <tr>
                <td><b>{{ $t("radon-content") }}</b></td>
                <td><b>{{ plotItem.GRN_RAD }} <span v-if="plotItem.GRN_RAD > 10" style="color: red; font-size: 20px">&#9888;</span></b></td>
              </tr>
              <tr>
                <td>{{ $t("site-contamination-kbs") }}</td>
                <td>{{ plotItem.GRN_CON }}</td>
              </tr>
              <tr>
                <td>{{ $t("infiltration-zones") }}</td>
                <td>{{ plotItem.GRN_INF }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({
  components: {},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem
}
</script>

